import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default class CourseOutlineRoute extends Route {
  @service("ember-store")
  store

  model(params) {
    return get(this, "store")
      .find("course", params.course_id)
      .then((course) => {
        return get(this, "store")
          .find("planbook", course.relationships.planbook.data.id)
          .then((planbook) => {
            return { courseId: course.id, course: course, planbook: planbook }
          })
      })
  }
}
